import React, { useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { CustomPinInputField } from "../../CustomHTMLElements/CustomPinInputField.component";
import { appInsights } from "../../AppInsight/AppInsight";

type SetPinComponentProps = {
  handleNext: () => void;
  handleGoBack: () => void;
  setValue: (value: string) => void;
  label: string;
};

const SetPinComponent = ({
  handleNext,
  label,
  setValue,
  handleGoBack,
}: SetPinComponentProps) => {
  let location = useLocation();
  const history = useHistory();
  useEffect(() => {
    appInsights.trackPageView({
      name: "SetPinComponent.tsx",
      isLoggedIn: true,
    });
  }, []);
  return (
    <div>
      <h4>Transaction PIN</h4>
      <p className="padding-none">Enter your transaction PIN to proceed</p>
      <br />
      <br />
      <CustomPinInputField
        setValue={(value) => {
          setValue(value);
        }}
        length={4}
        label={label}
      />
      <div className="d-flex justify-content-end" style={{ marginTop: "40%" }}>
        <div className="d-flex align-items-center">
          <p
            className="text-primary padding-none mr-3 cursor-pointer"
            onClick={() => (handleGoBack ? handleGoBack() : history.goBack())}
          >
            Go Back
          </p>
          <button className="btn btn-primary btn-radius" onClick={handleNext}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default SetPinComponent;
